import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { LockKey, ChartPieSlice, Plus, HandSwipeRight, HandCoins, GearSix, ArrowsClockwise, ListBullets } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { usePersonalFinanceGuard } from '@/hooks/usePersonalFinanceGuard';
import { PF } from './pfApi';
import PfDashboard from './PfDashboard';
import PfQuickAdd from './PfQuickAdd';
import PfTriage from './PfTriage';
import PfDuarte from './PfDuarte';
import PfCategoriesAccounts from './PfCategoriesAccounts';
import PfRecurring from './PfRecurring';
import PfAccountStatement from './PfAccountStatement';

const TABS = [
  { id: 'resumo', label: 'Resumo', icon: ChartPieSlice },
  { id: 'registar', label: 'Registar', icon: Plus },
  { id: 'triagem', label: 'Triagem', icon: HandSwipeRight },
  { id: 'extrato', label: 'Extrato', icon: ListBullets },
  { id: 'duarte', label: 'Duarte', icon: HandCoins },
  { id: 'recorrentes', label: 'Recorrentes', icon: ArrowsClockwise },
  { id: 'definicoes', label: 'Categorias & Contas', icon: GearSix },
];

export default function PersonalFinanceHubPage() {
  usePersonalFinanceGuard();
  const [tab, setTab] = useState('resumo');
  const [statementAccountId, setStatementAccountId] = useState('');
  const [categories, setCategories] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [settings, setSettings] = useState(null);

  const reload = useCallback(async () => {
    try {
      const [cRes, aRes, sRes] = await Promise.all([
        axios.get(`${PF}/categories`), axios.get(`${PF}/accounts`), axios.get(`${PF}/settings`),
      ]);
      setCategories(cRes.data); setAccounts(aRes.data); setSettings(sRes.data);
    } catch { toast.error('Erro ao carregar categorias/contas'); }
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const openStatement = (accountId) => { setStatementAccountId(accountId); setTab('extrato'); };

  return (
    <div className="fade-in" data-testid="personal-finance-hub-page">
      <div className="flex items-center gap-2 mb-1">
        <h1 className="font-heading font-medium text-xl text-brand-text">Finanças Pessoais</h1>
        <span className="flex items-center gap-1 text-[10px] font-semibold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full" data-testid="pf-owner-badge"><LockKey size={11} /> Pessoal</span>
      </div>
      <p className="text-xs text-brand-muted mb-4">Só tu vês esta zona, totalmente separada do módulo financeiro da clínica.</p>

      <div className="sticky top-0 z-20 bg-brand-bg/95 backdrop-blur-sm -mx-4 px-4 py-2 mb-5 border-b border-brand-border flex gap-2 overflow-x-auto">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5 border ${tab === t.id ? 'bg-brand-green text-white border-brand-green' : 'bg-white text-brand-muted border-brand-border hover:text-brand-text'}`}
            data-testid={`pf-tab-${t.id}`}>
            <t.icon size={13} /> {t.label}
          </button>
        ))}
      </div>

      {tab === 'resumo' && <PfDashboard />}
      {tab === 'registar' && <PfQuickAdd categories={categories} accounts={accounts} />}
      {tab === 'triagem' && <PfTriage categories={categories} />}
      {tab === 'extrato' && <PfAccountStatement accounts={accounts} categories={categories} initialAccountId={statementAccountId} />}
      {tab === 'duarte' && <PfDuarte />}
      {tab === 'recorrentes' && <PfRecurring categories={categories} accounts={accounts} />}
      {tab === 'definicoes' && <PfCategoriesAccounts categories={categories} accounts={accounts} settings={settings} reload={reload} onOpenStatement={openStatement} />}
    </div>
  );
}
